import { isFlightForceBundled } from 'lib/offer/isFlightForceBundled'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import React, { useCallback, useRef } from 'react'
import ModalBody from 'LuxKit/Modal/ModalBody'
import OfferCapacityWithAgesSelection from 'components/OfferPage/Filters/CapacityWithAges/OfferCapacityWithAgesSelection'
import ModalContent from 'LuxKit/Modal/ModalContent'

interface Props {
  capacities: Array<App.RoomCapacity>;
  offer: App.Offer;
}
function FlashMobileStickyHeaderFiltersCapacityModal(props: Props) {
  const { capacities, offer } = props
  const modalElement = useModalElementContext<string>()
  const formRef = useRef<HTMLFormElement>(null)
  const onClose = useCallback(() => {
    if (formRef.current?.reportValidity()) {
      modalElement.resolve('')
    }
  }, [modalElement])

  return (<ModalBase mode="drawer">
    <form onSubmit={onClose} ref={formRef}>
      <ModalHeader title="Who is going?" onCloseButtonClick={onClose} />
      <ModalBody>
        <ModalContent flush>
          <OfferCapacityWithAgesSelection
            capacities={capacities}
            disableMultiRoom={isFlightForceBundled(offer)}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Confirm',
          onClick: onClose,
        }}
      />
    </form>
  </ModalBase>)
}

export default FlashMobileStickyHeaderFiltersCapacityModal
